module.exports = __webpack_public_path__ + "static/img/jhIcon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jhIcon.png
// module id = zdwe
// module chunks = 13